
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/building/[...entity]",
      function () {
        return require("private-next-pages/building/[...entity].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/building/[...entity]"])
      });
    }
  